module.exports = __webpack_public_path__ + "lp/img/menu_icon_gray.79a54cc2.svg";